// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"6ea5bfbd","212":"4af02abf","396":"c56cbdf0","421":"25b1d5ea","655":"d3e4275c","996":"b6ea3a85"}[chunkId] + ".chunk.css";
};